import BaseClass from "../BaseClass.js";
import EmojisHandler from "./EmojisHandler";

export default class PageSection extends BaseClass {

    constructor(element) {
        super(element);
        this.contentUrl = null;
        this.requestData = null;
        this.visibility = 0;
        this.isIntersecting = false;
        this.minVisibility = 0.01;
        this.jqxhr = null;
        this.loading = false;
        this.loadTimeout = null;
        this.unloadTimeout = null;
        this.contentAvailable = true;

        this.init();
    }

    init() {
        let contentUrl = this.$element.data("content-url");
        if (contentUrl != undefined) {
            this.contentUrl = contentUrl;
        }

        let requestData = this.$element.data("requestdata");
        if (requestData != undefined) {
            this.requestData = requestData;
        }


        $(document).trigger("IntersectionObserver:observe", this.$element);
    }


    handleVisibilityChange(visibility, isIntersecting) {

        let inFullScreen = Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
        if (inFullScreen) {
            // Nichts tun sofern im Fullscreenmodus
            return false;
        }
        let mySelf = this;

        this.visibility = visibility;
        this.isIntersecting = isIntersecting;
        this.$element.attr('data-visibility', this.visibility);

        if (this.visibility >= this.minVisibility) {
            if (this.unloadTimeout != null) {
                clearTimeout(this.unloadTimeout);
                this.unloadTimeout = null;
            }

            if (!this.contentAvailable && !this.loading) {
                this.loadTimeout = setTimeout(function () {
                    mySelf.loadContent();
                }, 50);
            }
        } else {
            if (this.loadTimeout != null) {
                clearTimeout(this.loadTimeout);
                this.loadTimeout = null;
            }
            if (this.unloadTimeout != null) {
                clearTimeout(this.unloadTimeout);
                this.unloadTimeout = null;
            }
            if (this.contentAvailable) {
                this.unloadTimeout = setTimeout(function () {
                    mySelf.unloadContent();
                }, 50);
            }

        }
    }

    loadContent() {
        let mySelf = this;

        if (this.contentUrl != null) {
            let $contentElements = this.$element.children(':not([data-type="autoloadNext"])');
            if ($contentElements.length == 0) {
                if (this.jqxhr != null || this.loading) {
                    return false;
                }

                this.loading = true;

                this.jqxhr = $.post(this.contentUrl, this.requestData, function () {
                }, 'html')
                    .done(function (data) {
                        mySelf.insertContent(data);
                        mySelf.loading = false;
                        mySelf.jqxhr = null;
                    })
                    .fail(function (data) {
                        mySelf.insertContent(data);
                        mySelf.loading = false;
                        mySelf.jqxhr = null;
                    })
                    .always(function () {
                    });
            }
        }
    }

    insertContent(content) {

        let $content = $(content);
        let filteredContent = [];

        $content.each(function () {
            if ($(this).attr("data-type") != "autoloadNext") {
                filteredContent.push(this);
            }
        });

        this.$element.prepend(filteredContent);
        this.$element.css('min-height', 0);
        this.$element.css('padding-top', 0);

        this.contentAvailable = true;
    }

    unloadContent() {
        if (this.visibility > this.minVisibility) {
            // Abbruch, da die Sichtbarkeit sich geändert hat
            return;
        }
        let $contentElements = this.$element.children(':not([data-type="autoloadNext"])');
        if ($contentElements.length != 0) {
            let currentHeight = this.$element.height();
            $contentElements.remove();
            let $autoloadNext = this.$element.children('[data-type="autoloadNext"]');
            if ($autoloadNext.length > 0) {
                this.$element.css('padding-top', currentHeight);
            } else {
                this.$element.css('min-height', currentHeight);
            }
        }

        this.contentAvailable = false;
    }

    destroyListener() {
        $(document).trigger("IntersectionObserver:unobserve", this.$element);
    }
}